import fetch from '@giro/shared-utils/fetch.util';

type BodyType = {
  type: 'email' | 'phone';
  token: string;
  email: string;
  phone: string;
};

export default async function patchApiOnboardingsConfirmationsService(
  body: BodyType
) {
  return fetch(`onboardings/confirmations`, {
    method: 'PATCH',
    ms: 'ONBOARDING',
    auth: true,
    body: JSON.stringify(body),
  });
}
